import { useCallback, useEffect } from 'react'
import { useTimeTravel } from './useTimeTravel'

export const useEnableTimeTravel = () => {
  const timeTravel = useTimeTravel()

  const undoRedoHandler = useCallback(
    async (event: KeyboardEvent) => {
      const isMac =
        navigator &&
        navigator.platform &&
        navigator.platform.toUpperCase().includes('MAC')

      const isUndo =
        (isMac ? event.metaKey : event.ctrlKey) &&
        event.key.toLowerCase() === 'z'

      const isRedo =
        (isMac ? event.metaKey : event.ctrlKey) &&
        event.shiftKey &&
        event.key.toLowerCase() === 'z'

      if (isRedo) {
        event.preventDefault()
        await timeTravel.redo()
      } else if (isUndo) {
        event.preventDefault()
        await timeTravel.undo()
      }
    },
    [timeTravel],
  )

  useEffect(() => {
    document.addEventListener('keydown', undoRedoHandler)
    return () => {
      document.removeEventListener('keydown', undoRedoHandler)
    }
  }, [undoRedoHandler])
}
